import { render } from "./PagerLinkItem.vue?vue&type=template&id=73963f38&ts=true"
import script from "./PagerLinkItem.vue?vue&type=script&lang=ts"
export * from "./PagerLinkItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__